import { useTranslation } from 'react-i18next';
import { useContext } from '@/components/slider-type/context';
import { getValueByCondition } from '@/utils/utils';
import { useAppSelector } from '@/redux/store';
import { ConfigSlice } from '@/redux/config';
import '@/components/slider-type/components/header/header-v1.css';
import '@/components/slider-type/components/header/header-v2.css';

export default function Header() {
  const { slide, index } = useContext();
  const cssVersion = useAppSelector(ConfigSlice.selectors.cssVersion);
  const { t } = useTranslation();

  const getKey = (key: string) => {
    return key.replace('extra', 'extra-').replace('[', '').replace(']', '');
  };

  const getTitle = () => {
    return slide.type === 'submission'
      ? t(getValueByCondition(slide.title))
      : `${index + 1}. ${t(getValueByCondition(slide.title))}`;
  };

  if (!slide.message && !slide.title) return null;

  return (
    <div
      data-css-version={cssVersion}
      data-slider-type={slide.type}
      data-slider-key={getKey(slide.key)}
      className='slider-type-header'
    >
      {!!slide.message && (
        <div className='slider-type-header__message' dangerouslySetInnerHTML={{ __html: t(slide.message) }} />
      )}
      {!!slide.title && (
        <div
          className='slider-type-header__title'
          dangerouslySetInnerHTML={{
            __html: getTitle(),
          }}
        />
      )}
    </div>
  );
}
